const ONBOARDING_COMPLETE_VALUE = "true";

const canUseStorage = () => typeof window !== "undefined";

const readStorageValue = (storage, key) => {
  try {
    return storage?.getItem(key);
  } catch {
    return null;
  }
};

const writeStorageValue = (storage, key, value) => {
  try {
    storage?.setItem(key, value);
  } catch {
    // Ignore storage access issues and keep the app usable.
  }
};

export const isOnboardingCompleted = (key) => {
  if (!canUseStorage() || !key) {
    return false;
  }

  return [window.sessionStorage, window.localStorage].some(
    (storage) => readStorageValue(storage, key) === ONBOARDING_COMPLETE_VALUE
  );
};

export const completeOnboarding = (key) => {
  if (!canUseStorage() || !key) {
    return;
  }

  [window.sessionStorage, window.localStorage].forEach((storage) => {
    writeStorageValue(storage, key, ONBOARDING_COMPLETE_VALUE);
  });
};
